/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EBannerPriority } from "../types/EBannerPriority.ts";

/**
 * @description 1 = VeryLow | 2 = Low | 3 = Medium | 4 = High | 5 = VeryHigh |
 */
export const eBannerPrioritySchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)])
  .describe(
    "1 = VeryLow | 2 = Low | 3 = Medium | 4 = High | 5 = VeryHigh | ",
  ) as unknown as ToZod<EBannerPriority>;
